export default __webpack_public_path__ + "static/media/case3 (5).9604b4b9.jpg";